import { render, staticRenderFns } from "./Сms-reports.vue?vue&type=template&id=12e57f04&"
import script from "./Сms-reports.vue?vue&type=script&lang=js&"
export * from "./Сms-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports